<template>
  <router-view></router-view>
</template>

<script>
import { apiSystemInfo } from '@/request/api'

export default {
  data () {
    return {

    };
  },
  async created () {
    let res = await apiSystemInfo({

    })
    var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = res.sysconfig.logo.url;
    document.getElementsByTagName('head')[0].appendChild(link);

    document.title = res.sysconfig.sysname

    const s_5 = document.createElement('script');
    s_5.type = 'text/javascript';
    s_5.src = 'https://www.tuanyun99.com/ico/jiaoto/iconfont.js';
    document.body.appendChild(s_5);
  },
  methods: {},
};
</script>

<style scoped>
@import "./assets/css/bese.css";
</style>
